<template>
  <b-container class="wrap-rules">
    <div class="box-head">
      <h1>กฎเกณฑ์และกติกาการส่งผลงานเข้าประกวด</h1>
      <p>Rules & Regulations</p>
    </div>
    <img src="@/assets/images/awards-logo.png">
    <b-row>
      <b-col
        v-for="rule in rules"
        :key="rule.id"
        cols="12"
        md="6"
        class="col"
      >
        <div class="head">
          <div></div>
          <h2>{{ rule.name }}</h2>
        </div>
        <div class="content">
          <span v-html="rule.content"></span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      rules: state => state.awards.rules
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-rules {
  .box-head {
    padding: 22px 0;
    text-align: center;
    font-family: 'DB HelvethaicaMon X';
    font-size: 1.5rem;
    color: #6D6E71;

    h1 {
      margin-bottom: 8px;
      line-height: 0.8;
    }

    p {
      opacity: 0.5;
      padding-top: 8px;
      border-top: 1px solid #ccc;
    }

    @media only screen and (min-width: $break-m) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.75rem;

      h1 {
        margin: 0;
      }

      p {
        padding: 0;
        padding-left: 12px;
        border: none;
        border-left: 1px solid #ccc;
      }
    }
  }

  img {
    width: 100%;
    height: auto;
    background-color: $light;
  }

  .row {
    margin-top: 22px;

    .col {
      margin-bottom: 42px;

      .head {
        div {
          width: 12px;
          height: 12px;
          background-color: $active;
        }

        h2 {
          margin-top: -18px;
          font-size: 6rem;
          color: #6D6E71;
        }
      }

      .content {
        margin-top: -18px;
        font-size: 1.25rem;
        line-height: 1.2;

        p {
          .red-weight {
            color: $active;
          }
        }
      }
    }
  }
}
</style>
